/**
 * Ce a ramas din drumul catre PORTALUL VECHI: citirea unui cookie.
 *
 * `portalPost` - trimiterea unui formular la CodeIgniter, cu jetonul lui CSRF
 * - a plecat pe 11 septembrie 2026, odata cu ultimul ei apelant: legarea
 * codului de acces (`user/pair_access_code`) are acum capatul ei in v4
 * (`POST /api/v2/user/pair_access_code`). Schimbarea firmei plecase pe 9
 * septembrie. Portalul vechi nu mai sta pe server; nimic din v4 nu mai
 * trimite spre el.
 *
 * `readCookie` ramane fiindca il mai citesc doua locuri (`Shell.tsx` pentru
 * `user_sidebar`, `TicketRemote.tsx` pentru `csrf_token` al formularului de
 * Remote Connect). Cand pleaca si alea, se sterge si fisierul.
 */

export function readCookie(name: string): string {
  const hit = document.cookie.split('; ').find((c) => c.startsWith(name + '='))
  return hit ? decodeURIComponent(hit.slice(name.length + 1)) : ''
}
